class Search {
    constructor() {
        this.searchContainer = ".js-search-container";
        this.searchInput = Array.from(document.querySelectorAll(".js-search-input"));
        this.searchTriggers = Array.from(document.querySelectorAll(".js-search-trigger"));
        this.searchSubmit = Array.from(document.querySelectorAll(".js-search-submit"));
    }

    watchSearch() {
        const searchInput = this.searchInput;
        const searchSubmit  = this.searchSubmit;

        searchInput.forEach(input => {
            input.addEventListener("focus", () => {
                this.activateSearch(input);
            });

            input.addEventListener("keydown", () => {
                searchSubmit.forEach(submit => {
                    setTimeout(function() {
                        if(input.value) {
                            submit.removeAttribute("disabled");
                        } else {
                            submit.setAttribute("disabled", "disabled");
                        }
                    }, 200);
                })
            })
        });
    }

    focusInput() {
        const searchInput = this.searchInput;
        const triggers = this.searchTriggers;
        triggers.forEach(trigger => {
            if (trigger.classList.contains("search__trigger--open")) {
                trigger.addEventListener("click", () => {
                    const container = trigger.parentNode;
                    const searchInput = container.querySelector(
                        ".js-search-input"
                    );
                    setTimeout(function() {
                        searchInput.focus();
                    }, 200);
                });
            } else if(trigger.classList.contains("search__trigger--close")) {
                trigger.addEventListener("click", () => {
                    searchInput.forEach(input => {
                        this.cancelSearch(input);
                    })
                })
            }
        });
    }

    cancelSearch(input) {
        input.value = "";
        input.blur();
    }

    activateSearch(input) {
        const container = input.closest(this.searchContainer);
        const triggerInput = container.querySelector(
            ".search__bar__trigger__input"
        );
        triggerInput.checked = true;
    }

    init() {
        this.watchSearch();
        this.focusInput();
    }
}
export default Search;



// WEBPACK FOOTER //
// ../project/craft/src/components/search/search.js